enum InputFieldTypes {
    Text = "text",
    TextMulti = "multi",
    TextRich = "rich",
    Password = "pass",
    Number = "number",
    Date = "date",
    Time = "time",
    Check = "check",
    Radio = "radio",
    Select = "select",
    List = "list",
    Colour = "colour",
}

export default InputFieldTypes;

export type InputFormFieldType = InputFieldTypes.Text | InputFieldTypes.TextMulti | InputFieldTypes.TextRich | InputFieldTypes.Password | InputFieldTypes.Number | InputFieldTypes.Check | InputFieldTypes.Date | InputFieldTypes.Radio | InputFieldTypes.Select | InputFieldTypes.Time | InputFieldTypes.List | InputFieldTypes.Colour; 